import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TransactionRow from 'modules/common/components/TransactionRow';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';
import StructuralType from '../components/StructuralType';

function BuildingKindsContent({
  handleAddKindModal,
  handleEdit,
  handleRemove,
  buildingKindId,
  getList,
  showData,
  dataInfo,
  history,
  getStructuralTypeList,
  structuralTypeList,
  removeStructuralTypeData,
  ordinanceRevisionId,
}) {

  useEffect(() => {
    if (_.isEmpty(buildingKindId)) return;
    showData(buildingKindId)
    getStructuralTypeList(buildingKindId, { ordinance_revision_id: ordinanceRevisionId });
  }, []);
  useEffect(() => {
    if (_.isEmpty(buildingKindId)) return;
    showData(buildingKindId);
    getStructuralTypeList(buildingKindId, { ordinance_revision_id: ordinanceRevisionId });
  }, [buildingKindId, ordinanceRevisionId]);

  const removeStructuralType = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this Building Structural Type?',
      () => {
        removeStructuralTypeData(buildingKindId, data.id, () => {
          getList({ isPaginate: 1 });
          history.push(
            `/rpt/building/settings/building-kinds/${buildingKindId}`
          );
          showData(buildingKindId);
          getStructuralTypeList(buildingKindId, { ordinance_revision_id: ordinanceRevisionId });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddKindModal}
            className="btn btn-owner font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Kind of Building
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEdit(dataInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemove(dataInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          {!_.isEmpty(dataInfo) ? (
            <React.Fragment>
              <div className="row px-3 mt-3">
                <div className="col-12">
                  <table className="transaction-table table table-borderless table-sm table-striped">
                    <tbody>
                      <TransactionRow
                        title="Name"
                        value={_.get(dataInfo, 'attributes.name') || '--'}
                      />
                      <TransactionRow
                        title="Description"
                        value={_.get(dataInfo, 'attributes.description') || '--'}
                      />
                      <TransactionRow
                        title="Is Active"
                        value={
                          _.get(dataInfo, 'attributes.is_active')
                            ? 'YES'
                            : 'NO'
                            || '--'}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
          <div className="mt-2 ml-3">
            <StructuralType
              dataInfo={dataInfo}
              structuralTypeList={structuralTypeList}
              buildingKindId={buildingKindId}
              removeStructuralType={removeStructuralType}
              ordinanceRevisionId={ordinanceRevisionId}
            />
          </div>
        </div>
      </div>
    </>
  );
}

BuildingKindsContent.propTypes = {
  handleAddKindModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  buildingKindId: PropTypes.string.isRequired,
  removeStructuralTypeData: PropTypes.instanceOf(Function).isRequired,
  getStructuralTypeList: PropTypes.instanceOf(Function).isRequired,
  structuralTypeList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  structuralTypeList:
    _.get(api, `${c.GET_BUILDING_STRUCTURAL_TYPE_LIST}.list`) || [],
  buildingKindId: _.get(match, 'params.buildingKindId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingKindsContent);
